/**
 * Csv Schema of CentroDeCusto
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CentroDeCusto} from '@/model/resource/CentroDeCusto'

/* TODO: review generated schema */
export class CsvCentroDeCustoSchema extends Schema {
  readonly name = 'CsvCentroDeCusto'

  readonly fieldSet: FieldSet<CentroDeCusto> = {
    idCentroDeCustoPk: schema => schema.model.idCentroDeCustoPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    nome: schema => schema.model.nome,
  }
}
